import React from "react";
import "./DialogoConfirmacion.css";
import { Modal, ModalDialog, Typography, VariantProp } from "@mui/joy";
import { Column, Row } from "../MaterialGridComponents";
import CustomInput from "../CustomInput/CustomInput";
import {
  Dangerous,
  InfoOutlined,
  PriorityHigh,
  TaskAlt,
  WarningAmber,
} from "@mui/icons-material";

interface ContainerProps {
  titulo: string;
  texto: string | React.ReactNode;
  textoBotonSi: string;
  textoBotonNo: string;
  variantBotonSi: VariantProp;
  colorBotonSi: "danger" | "neutral" | "primary" | "success" | "warning";
  variantBotonNo: VariantProp;
  colorBotonNo: "danger" | "neutral" | "primary" | "success" | "warning";
  variantDialog: VariantProp;
  colorDialogo: "danger" | "neutral" | "primary" | "success" | "warning";
  open: boolean;
  ordenBotonesSINO: boolean;
  setOpen: (open: boolean) => void;
  handleClickConfirmar: () => void;
  handleClickCancelar?: () => void;
}

export const DialogoConfirmacion: React.FC<ContainerProps> = ({
  texto,
  titulo,
  ordenBotonesSINO = false,
  open,
  setOpen,
  handleClickConfirmar,
  handleClickCancelar,
  textoBotonSi,
  textoBotonNo,
  colorBotonSi,
  variantBotonNo = "solid",
  colorBotonNo,
  variantBotonSi = "solid",
  colorDialogo,
  variantDialog = "plain",
}) => {
  const handleClickConfirmarAccion = async () => {
    await handleClickConfirmar();
    setOpen(false);
  };

  const getTitleIcon = () => {
    switch (colorDialogo) {
      case "danger":
        return <Dangerous />;
      case "primary":
        return <InfoOutlined />;
      case "success":
        return <TaskAlt />;
      case "warning":
        return <WarningAmber />;
      default:
        return null;
    }
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalDialog color={colorDialogo} variant={variantDialog}>
        <Column xs={12}>
          <Row spacing={2} marginBottom={1}>
            <Typography id="nested-modal-title" level="h2" color={colorDialogo}>
              {getTitleIcon()} {titulo}
            </Typography>
            <Typography
              id="nested-modal-description"
              textColor="text.tertiary"
              color={colorBotonSi}
            >
              {texto}
            </Typography>
          </Row>
          {ordenBotonesSINO ? (
            <Row
              container
              justifyContent="space-between"
              alignItems="center"
              sx={{ width: "100%" }}
            >
              <Column xs={5.9}>
                <CustomInput
                  type="button"
                  variant={variantBotonSi}
                  color={colorBotonSi}
                  onClick={handleClickConfirmarAccion}
                  value={textoBotonSi}
                />
              </Column>
              <Column xs={5.9} alignSelf={"end"}>
                <CustomInput
                  type="button"
                  variant={variantBotonNo}
                  color={colorBotonNo}
                  onClick={() =>
                    handleClickCancelar !== undefined
                      ? handleClickCancelar()
                      : setOpen(false)
                  }
                  value={textoBotonNo}
                />
              </Column>
            </Row>
          ) : (
            <Row
              container
              justifyContent="space-between"
              alignItems="center"
              sx={{ width: "100%" }}
            >
              <Column xs={5.9}>
                <CustomInput
                  type="button"
                  variant={variantBotonNo}
                  color={colorBotonNo}
                  onClick={() =>
                    handleClickCancelar !== undefined
                      ? handleClickCancelar()
                      : setOpen(false)
                  }
                  value={textoBotonNo}
                />
              </Column>
              <Column xs={5.9} alignSelf={"end"}>
                <CustomInput
                  type="button"
                  variant={variantBotonSi}
                  color={colorBotonSi}
                  onClick={handleClickConfirmarAccion}
                  value={textoBotonSi}
                />
              </Column>
            </Row>
          )}
        </Column>
      </ModalDialog>
    </Modal>
  );
};
